import { verticalRequest } from './http';

// Paged. `search` matches name and address; `status` is `active`, `archived`
// or `all`. A condo is an engine site: its `id` is the `site_id` used on the
// engine prefix (coverage, holidays, routing overrides, ticket rows).
export const listCondos = params =>
  verticalRequest({ path: '/condos', params });

export const getCondo = id => verticalRequest({ path: `/condos/${id}` });

// The address is placed on the map on save (422 `address_not_found`).
export const createCondo = fields =>
  verticalRequest({ method: 'post', path: '/condos', data: fields });

// Partial `{name, address, description}`; a changed address is placed again.
export const updateCondo = (id, fields) =>
  verticalRequest({ method: 'put', path: `/condos/${id}`, data: fields });

// Archive or restore.
export const setCondoActive = (id, active) =>
  verticalRequest({
    method: 'put',
    path: `/condos/${id}/active`,
    data: { active },
  });

// 409 `in_use` (with `units` and `tickets` booleans): archive instead.
export const deleteCondo = id =>
  verticalRequest({ method: 'delete', path: `/condos/${id}` });
